<template>
  <div>
    <v-card
      rounded="sm"
      elevation="2"
      :disabled="disabled"
      @click="onClick()"
    >
      <v-card-text class="py-0">
        <v-container>
          <v-row>
            <v-col class="d-flex align-items-center justify-content-center">
              <img
                :src="`/images/icons/challenge_${disabled ? 'gray' : 'blue'}_icon.svg`"
              >
              <v-container>
                <v-row>
                  <v-col class="py-0">
                    <p class="mb-2 text-black font-13"> 
                      <span class="font-weight-bold">Aplicação {{ challenge_type_text }}:</span> {{ challenge_type_title }}
                    </p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    :md="6"
                    :sm="12"
                    :xs="12"
                    class="py-0 d-flex align-items-center"
                  >
                    <p
                      class="d-flex align-items-center m-0 font-12"
                      :style=" { 'min-width': isMobile ? '270px': '' } "
                    >
                      <img
                        src="/images/icons/calendar_gray_icon.svg"
                        style="width: 14px; height: 14px;"
                        class="mr-1"
                      > {{ cycle.begin_challenge_apply_formatted_with_hours }} até {{ cycle.end_challenge_apply_formatted_with_hours }}
                    </p> 
                  </v-col>
                  <v-col
                    :md="3"
                    :sm="12"
                    :xs="12"
                    class="py-0"
                  >
                    <p
                      class="font-12 m-0"
                      :style=" { 'min-width': isMobile ? '270px': '' } "
                    >
                      {{ count_questions }} questões / {{ cycle.challenge_minutes }} minutos
                    </p>
                  </v-col>
                  <v-col
                    :md="3"
                    :sm="12"
                    :xs="12"
                    class="py-0"
                  >
                    <p class="font-12 m-0">
                      {{ status_text }}
                    </p>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <ModalChallenge @close="showModalChallenge = false" />
    <v-dialog
      v-model="showStartScreen"
      max-width="1000"
      persistent
      value="true"
    >
      <StartScreen
        :cycle="cycle"
        @cancel="showStartScreen = false"
      />
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import ModalChallenge from '@/student/pages/cycle/components/challenge/Modal.vue'
import StartScreen from '@/student/components/challenge/StartScreen.vue';

export default {
      components: {
        ModalChallenge,
        StartScreen,
      },
      props: {  
        cycle: {
          type: Object,
          required: true
        },
      },
      data(){
        return {
          showStartScreen: false,
        }
      },
      computed: {
        showModalChallenge: {
          get() {
            return this.$store.state.challenge.showModalChallenge;
          },
          set(value) {
            if(!value)
              this.SET_CHALLENGE();
            this.$store.commit('SHOW_MODAL_CHALLENGE', value);
          },
        },
        ...mapGetters(['view_plan','selectedCycle']),
        challenge_type_text(){
          return this.cycle.challenge_type == 'print' ? 'impressa' : 'online'
        },
        challenge_type_title(){
          let text = this.cycle.challenge_type == 'print' ? 'sua escola aplicará a prova em sala de aula' : 'Realize o desafio direto na plataforma';
          return text;
        },
        count_questions(){
          return this.cycle.challenge ? this.cycle.challenge.count_questions : this.cycle.modules.length * 6;
        },
        minutes(){
          return this.cycle.challenge ? this.cycle.challenge.minutes : this.cycle.challenge_minutes;
        },
        disabled(){
          if(!this.cycle.started){
            console.log('desabilitado pq o ciclo nao começou');
            
            return true;
          }

          if(this.cycle.started && !this.cycle.is_finished && !this.cycle.challenge_released ){
            console.log('desabilitado pq o ciclo começou, mas o desafio não foi liberado');
            return true;
          }
          
          if(this.cycle.is_finished && (!this.cycle.challenge || !this.cycle.challenge.finished_at || !this.cycle.challenge.started_at)){
            if(this.cycle.challenge && this.cycle.challenge.count_unfinished_retries > 0) {
              return false;
            }
            console.log('desabilitado pq o ciclo terminou, mas o desafio não foi realizado');
            return true;
          }

          if(this.cycle.challenge && this.cycle.challenge.finished_at){
            console.log('desabilitado pq o desafio foi finalizado e o resultado não foi liberado');
            return !this.cycle.challenge_result_released;
          }

          return false

        },
        status_text(){
          if(this.cycle.challenge && this.cycle.challenge.count_unfinished_retries > 0){
            return 'Desafio reaberto';
          }
          if(this.cycle.challenge && this.cycle.challenge.finished_at){
            return 'Aplicação finalizada';
          }
          if(!this.cycle.challenge_released){
            return 'Aplicação a iniciar';
          }
          if(this.cycle.challenge && this.cycle.is_finished && !this.cycle.challenge.finished_at){
            return 'Aplicação não realizada';
          }
          return 'Aplicação em andamento';
        },
        cycle_not_started_and_challenge_released(){
          return !this.cycle.started && this.cycle.challenge_released 
        },
      },
      methods: {
        ...mapActions(['getChallenge','createChallenge']),
        ...mapMutations(['SET_CHALLENGE']),
        onClick(){
          if(this.cycle.is_current && this.cycle.challenge_type == 'print' && !this.cycle.challenge_result_released){
            this.$swal.fire({
              title: 'Desafio impresso',
              html: `<div style="text-align: center; white-space: pre-wrap; word-wrap: break-word; color: #000000;">
                    O desafio do ${this.selectedCycle.name} será aplicado na modalidade impressa, o que significa que a escola aplicará na sua sala de aula e você não poderá realizá-lo na plataforma. 
                      Fique atento às informações e, qualquer dúvida, procure a Coordenação da sua escola.</div>`,
              icon: 'warning',
              confirmButtonText: 'Ok',
              confirmButtonColor: '#7066e0',
              width: '600px',
              allowOutsideClick: false,
            });
            return;
          }else {

              if(this.cycle.challenge_released && !this.cycle.challenge){
                this.createChallenge({ cycle_config_id: this.cycle.id })
                .then(() => {
                  this.SET_CYCLE(this.cycle)
                  this.showStartScreen = true;
                })
                return;
              }
              
              if(this.cycle.challenge && this.cycle.challenge.is_running){
                this.$router.push({ name: 'challenge.index', params: { challenge_id: this.cycle.challenge.id } });
                return; 
              }

              if(this.cycle.is_finished && this.cycle.challenge && this.cycle.challenge.count_unfinished_retries > 0 && !this.cycle.challenge.started_at){
                this.getChallenge({id: this.cycle.challenge.id})
                .then(() => {
                  this.showStartScreen = true;
                });
                return;
              }
              
              if(this.cycle.is_between_apply_dates && this.cycle.challenge && !this.cycle.challenge.finished_at && !this.cycle.challenge.started_at){
                this.getChallenge({id: this.cycle.challenge.id})
                .then(() => { 
                  this.showStartScreen = true;
                })
                return;
              }

              if(this.cycle.challenge && this.cycle.challenge.finished_at && this.cycle.challenge_result_released){
                this.getChallenge({id: this.cycle.challenge.id})
                .then(() => { 
                  this.showModalChallenge = true;
                })
                return;
              }

              if(this.cycle.challenge && this.cycle.challenge.finished_at && !this.cycle.challenge_result_released){
                this.$swal.fire({
                  title: 'Resultado não liberado',
                  html: `<div style="text-align: center; white-space: pre-wrap; word-wrap: break-word; color: #000000;">
                    O desafio do ${this.selectedCycle.name} já foi finalizado, mas o resultado ainda não foi liberado. Fique atento às informações e, qualquer dúvida, procure a Coordenação da sua escola.</div>`,
                  icon: 'warning',
                  confirmButtonText: 'Ok',
                  confirmButtonColor: '#7066e0',
                  width: '600px',
                  allowOutsideClick: false,
                });
                return;
              }

          }
        } 
    }
}
</script>